import { userAppContext } from '../../context/Context';
import { DATASETS } from '../Constants';
import DetailGene from './DetailGene';
import DetailDisgenet from './DetailDisgenet';
import DetailVariant from './DetailVariant';
import DetailDrug from './DetailDrug';
import { getTitle, getId } from '../Constants';
import SharedModal from '../Modal/SharedModal';
import { useSidebarDetailContent } from '../../hooks/useSidebarDetailContent';
import { XMarkIcon } from '@heroicons/react/16/solid';
import Loader from '../Common/Loader';

interface SideBarContentProps {
  selectedInfoItem: any;
  view: string;
  showModalExample: boolean;
  setShowModalExample: (show: boolean) => void;
  renderInPanel?: boolean;
  onPanelClose?: () => void;
}

function SideBarContent({
  selectedInfoItem,
  view,
  showModalExample,
  setShowModalExample,
  renderInPanel = false,
  onPanelClose,
}: SideBarContentProps) {
  const { authorization, isAuthenticated, setIsAuthenticated } = userAppContext();

  const { dataSource, vocabulary, tipo, loading } = useSidebarDetailContent({
    selectedInfoItem,
    view,
    authorization,
    isAuthenticated,
    onAuthStateChange: setIsAuthenticated,
  });

  // Extract the values to pass to detail components
  const detailValues = tipo === DATASETS.CHEMICALS ? dataSource : dataSource.payload;
  const diseaseIdFromItem = getId(selectedInfoItem);
  const diseaseIdFromPayload = detailValues?.diseaseID ?? detailValues?.id;
  const diseaseId = diseaseIdFromItem || diseaseIdFromPayload;

  const content = (
    <>
      {tipo === DATASETS.DISEASES && (
        <DetailDisgenet values={detailValues} vocabulary={vocabulary} diseaseId={diseaseId} />
      )}
      {tipo === DATASETS.GENES && <DetailGene values={detailValues} />}
      {tipo === DATASETS.VARIANTS && <DetailVariant values={detailValues} />}
      {tipo === DATASETS.CHEMICALS && <DetailDrug values={detailValues} />}
    </>
  );

  if (renderInPanel && selectedInfoItem) {
    return (
      <div className="flex flex-col h-full bg-white border-r border-gray-200 overflow-hidden">
        <div className="flex items-center justify-between flex-shrink-0 px-4 py-3 border-b border-gray-200 bg-gray-50">
          <h2 className="text-sm font-semibold text-gray-900 truncate min-w-0 mb-0">
            {getTitle(selectedInfoItem)}
          </h2>
          <button
            type="button"
            onClick={onPanelClose}
            className="p-1.5 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-200 flex-shrink-0"
            aria-label="Close"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-2 min-h-0">
          {loading ? (
            <div className="flex justify-center items-center h-24">
              <Loader isInnerSpinner />
            </div>
          ) : (
            content
          )}
        </div>
      </div>
    );
  }

  return (
    <>
      {showModalExample && selectedInfoItem && (
        <SharedModal
          open={showModalExample}
          setOpen={setShowModalExample}
          title={getTitle(selectedInfoItem)}
          content={content}
        />
      )}
    </>
  );
}

export default SideBarContent;
